"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 25. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Approval status of release part for concrete role.
 * @author Radek Beran
 */


var RoleApprovalStatus =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(RoleApprovalStatus, _DomainObject_1$Domai);

  /**
   * Role approval status.
   * @param role role
   * @param indication type of visual approval indication
   * @param userInfo user who approved the prices
   */
  function RoleApprovalStatus(role, indication, userInfo) {
    var _this;

    _classCallCheck(this, RoleApprovalStatus);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RoleApprovalStatus).call(this));
    _this.role = role;
    _this.indication = indication;
    _this.userInfo = userInfo;
    return _this;
  }

  return RoleApprovalStatus;
}(DomainObject_1.DomainObject);

exports.RoleApprovalStatus = RoleApprovalStatus;